/*
function sortResults(type) {
	var resultsCount = document.getElementById('results').childNodes.length;
	switch(Number(type)) {
		case 1: 
			console.log('Sorting by lowest price!');
            sortByLowestPrice(resultsCount);
			break;
		case 2: 
			console.log('Sorting by highest price!');
            sortByHighestPrice(resultsCount);
			break;
		case 3: 
			console.log('Sorting by (earliest) departure time!');
			sortByEarliestDeparture(resultsCount);
			break;
		case 4: 
			console.log('Sorting by (latest) departure time!');
            sortByEarliestDeparture(resultsCount);
            var results = document.getElementById('results').childNodes;
            for(var i = 0; i < results.length; i++) {
                var item = results[i];
                document.getElementById('results').removeChild(item);
                document.getElementById('results').appendChild(item);
            }
			break;
		case 5: 
			console.log('Sorting by (earliest) arrival time!');
            sortByEarliestArrival(resultsCount);
			break;
		case 6: 
			console.log('Sorting by (latest) arrival time!');
			break;
        case 7:
			console.log('Sorting by carbon!');
            sortByCarbon(resultsCount);
			break;
		default: console.log('oops switch statement for sort options died');
	}
}

function sortByLowestPrice(size) {
	for(var i = 0; i < size; i++)
		$("#result-" + (i+1)).insertAfter( $("#result-"+i) );
}

function sortByHighestPrice(size) {
	for(var i = size-1; i > 0; --i) 
		$("#result-" + (i-1)).insertAfter( $("#result-"+i) );
}

function sortByEarliestDeparture(size) {
	// For departure times:
	var departureTimes = [];
    for(var i = 0; i < size; i++) 
		$("#result-" + (i + 1)).insertAfter($("#result-" + i));
	for(var i = 0; i < size; i++) {
		// For each result item, traverse down its children to access the time
		var depart = document
			.getElementById('results')
			.childNodes[i] // div id 0 ~ results.length
			.childNodes[3] // div class flight-container 
            .childNodes[0] // ul summary-list
            .childNodes[1] // li summary-list-item
			.innerHTML;

        // Get the time substring
        depart = depart.substring(depart.indexOf('>')+1, depart.lastIndexOf('<'))

		// Parse the time appropriately to get the departure 
		//	(time must be in the format HH:MM am/pm)
		depart = depart.replace(' ', '');
		depart = depart.replace(' ', '');
		if(depart.indexOf(':') == 1) depart = '0' + depart;
		depart = depart.substr(0, 5) + ' ' + depart.substr(5); 
	
		// Add to an array for sorting
		departureTimes.push({id: i, time: depart});		
	}
	
	// Sort the departure time array by the time
	departureTimes.sort(function (i, j) {
		return Date.parse('01/01/2015 ' + i.time) 
			 - Date.parse('01/01/2015 ' + j.time);
	});

	// Reorder the result items according to the departureTimes array
	for(var i = 0; i < size; i++) {
		var resultItem = document.getElementById('result-'+departureTimes[i].id);
		document.getElementById('results').removeChild(resultItem);
		document.getElementById('results').appendChild(resultItem);
	}
}

function sortByEarliestArrival(size) {
	// For arrival times:
	var arrivalTimes = [];
    for(var i = 0; i < size; i++) 
		$("#result-" + (i + 1)).insertAfter($("#result-" + i));
	for(var i = 0; i < size; i++) {
		// For each result item, traverse down its children to access the time
		var arrive = document
			.getElementById('results')
			.childNodes[i] // div id 0 ~ results.length
			.childNodes[3] // div class flight-container 
            .childNodes[1] // ul summary-list
            .childNodes[3] // li summary-list-item
			.innerHTML;

        // Get the time substring
        arrive = arrive.substring(arrive.indexOf('>')+1, arrive.lastIndexOf('<'))

		// Parse the time appropriately to get the arrival 
		//	(time must be in the format HH:MM am/pm)
		arrive = arrive.replace(' ', '');
		arrive = arrive.replace(' ', '');
		if(arrive.indexOf(':') == 1) arrive = '0' + arrive;
		arrive = arrive.substr(0, 5) + ' ' + arrive.substr(5); 
	
		// Add to an array for sorting
		arrivalTimes.push({id: i, time: arrive});		
	}
	
	// Sort the arrival time array by the time
	arrivalTimes.sort(function (i, j) {
		return Date.parse('01/01/2015 ' + i.time) 
			 - Date.parse('01/01/2015 ' + j.time);
	});

	// Reorder the result items according to the arrivalTimes array
	for(var i = 0; i < size; i++) {
		var resultItem = document.getElementById('result-'+arrivalTimes[i].id);
		document.getElementById('results').removeChild(resultItem);
		document.getElementById('results').appendChild(resultItem);
	}
}
*/

////////////////////////////////////////////////////////////////////////////////////////////////////

//global flag to signify if results are already sorted
//let CARBONSORTED = false, PRICESORTED = false;

export function sortByCarbon() {
	console.log("in sortByCarbon");
	//sort if results are not sorted by carbon yet;
	//if (!CARBONSORTED){
		ascCarbon();	//only ascending order for now
		//remove the active arrow icon on price
		$('#factor-price > .icon-active').removeClass('icon-active').addClass('icon-sort');
	//}
}	

function ascCarbon(){
	$('#factor-carbon > .icon-sort').removeClass('icon-sort').addClass('icon-active');
	let resultsArr = $('#results').children();
	resultsArr.sort(function(a, b){
		var aCarbonValue = a.childNodes[0].getElementsByClassName('carbon-container')[0].innerHTML;
		aCarbonValue = Number(aCarbonValue.substring(0, aCarbonValue.indexOf('k')));
		var bCarbonValue = b.childNodes[0].getElementsByClassName('carbon-container')[0].innerHTML;
		bCarbonValue = Number(bCarbonValue.substring(0, bCarbonValue.indexOf('k')));
		//the strings are compared using Unicode value
		if (aCarbonValue == '?')
			aCarbonValue = Infinity;
		if (bCarbonValue == '?')
			bCarbonValue = Infinity;

		if (aCarbonValue > bCarbonValue)
			return 1;
		if (aCarbonValue < bCarbonValue)
			return -1;
		return 0;	
	}); //resultsArr is sorted in increasing order

	displaySortedResults(resultsArr);
	//CARBONSORTED = true;
	//PRICESORTED = false;

}
export function sortByPrice(){
	//sort if results are not sorted by price yet	
	//if (!PRICESORTED){
		ascPrice(); //only ascending order for now
		//remove the active arrow icon on carbon
		$('#factor-carbon > .icon-active').removeClass('icon-active').addClass('icon-sort');
	//}
}

function ascPrice(){
	//show arrow icon
	$('#factor-price > .icon-sort').removeClass('icon-sort').addClass('icon-active');

	let resultsArr = $('#results').children();

	resultsArr.sort(function(a, b){
		var aPriceValueText = a.childNodes[0].getElementsByClassName('price-container')[0].innerText;
		var bPriceValueText = b.childNodes[0].getElementsByClassName('price-container')[0].innerText;

		//converting strings to number
		var aPriceValue = Number(aPriceValueText.substring(1).replace(',',''));	
		var bPriceValue = Number(bPriceValueText.substring(1).replace(',',''));

		//console.log(Number(aPriceValue.substring(1).replace(',','')), Number(bPriceValue.substring(1)));

		if (aPriceValue > bPriceValue){
			console.log(aPriceValue+" > "+bPriceValue);
			return 1;
		}
		else if (aPriceValue < bPriceValue){
			console.log(aPriceValue+" < "+bPriceValue);
			return -1;
		}
		else{
			console.log(aPriceValue+" = "+bPriceValue)
			return 0;
		}
	}); //resultsArr is sorted in increasing order

	displaySortedResults(resultsArr);
	//PRICESORTED = true;
	//CARBONSORTED = false;

}

function displaySortedResults(resultsArr){
	var resultsDiv = document.getElementById('results');
	while (resultsDiv.lastChild){
		resultsDiv.removeChild(resultsDiv.lastChild);
	}	//remove previous results

	for (var i = 0; i < resultsArr.length; i++)
	{
		resultsDiv.appendChild(resultsArr[i]);	//append newly sorted results
	}
}

//export {sortByCarbon, sortByPrice}



// WEBPACK FOOTER //
// ./sort.js